module.exports = __webpack_public_path__ + "static/angelo_ozelame-3d0b7961fbe44c730392c528d07652a0.png";